import type { Candidate } from '../types/landing'

export const candidates: Candidate[] = [
  {
    id: 'ower-cassetta',
    order: 1,
    name: 'Ower Antonio Cassetta Vallejo',
    company: 'KZ Professional S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/nsL94ciLCvjcUHD1EYjGvy/Ower_-_Imagen_retocada.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/eLtxWtCNtHvdmv9AXRBg7t/ZK_servicios_profesionales_integrados.png',
    bio: 'Socio director de KZ Professional SAS, contador público con maestría en Valoración de Activos e Intangibles y más de 30 años de experiencia en consultoría empresarial. Experto en costos y presupuestos, ha ocupado cargos directivos y de control, y asesora en estructuración financiera, valoración de empresas, auditoría y asuntos tributarios.',
  },
  {
    id: 'miguel-garcia',
    order: 2,
    name: 'Miguel Ángel García López',
    company: 'Grupo Contable Asesores S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/rWfgTnpx7WA96myNNJkHkz/Miguel_Ajustada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/69ub1ExCLH42BjzwuidQkD/GRUPO_CONTABLE_ASESORES_SAS.jpg',
    bio: 'Socio director de Grupo Contable Asesores S.A.S., contador público y experto tributarista, especializado en internacionalización de la economía. Cuenta con más de 30 años de experiencia como gerente, revisor fiscal, auditor y asesor empresarial. Es docente, escritor y líder gremial, con participación en juntas directivas y organismos técnicos de la profesión.',
  },
  {
    id: 'luis-franco',
    order: 3,
    name: 'Luis Hernando Franco Murgueitio',
    company: 'Franco Murgueitio & Asociados Asesores y Revisores S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/r2qgdZ471DaeWpxrZBCzfV/Luis_H_mejorada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/qxQ4BWg73hzKAQhWkQsbcY/franco_murgueitio_y_asociados.webp',
    bio: 'Socio director de Franco Murgueitio & Asociados, abogado especializado en Derecho Administrativo y contador público con formación en tributación internacional. Su experiencia abarca derecho empresarial, contratación internacional, estructuración patrimonial y planeación tributaria. Ha liderado departamentos tributarios, integrado juntas directivas y organismos profesionales, y ejercido como docente y asesor de empresas nacionales e internacionales.',
  },
  {
    id: 'alfredo-lopez',
    order: 4,
    name: 'Alfredo José López Tobón',
    company: 'Alfredo López y Cía. S.A.S. BIC',
    photo: 'https://cdn.magicpatterns.com/uploads/2V5RspsBDZoqCyBw8Lq73k/Alfredo_mejorada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/i2Pe5ni3VeL3iFfMHdH6Yq/LOGO_ALFREDO_ASOCIADOS.png',
    bio: 'Socio de Alfredo López & CIA Ltda., abogado y contador público, magíster en Derecho Tributario y especialista en Finanzas y Gestión Tributaria. Cuenta con 25 años de experiencia profesional en empresas como KPMG, Sisval y Tree Services. Ha sido docente universitario y miembro de juntas directivas de entidades empresariales y regionales.',
  },
  {
    id: 'jorge-fernandez',
    order: 5,
    name: 'Jorge Isaac Fernández Cifuentes',
    company: 'Partes Equipos y Suministros S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/bdNgyJNWcNNYnMhmXL1nUw/Jorge_mejorada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/qJAZCFf8HxARgkGw6iKvVg/LOGO_PARTES_Y_SUMINISTROS_SAS.png',
    bio: 'Socio gerente y representante legal de Partes Equipos y Suministros S.A.S. (PEYS), contador público, especialista en Finanzas y magíster en Administración. Cuenta con más de 40 años de trayectoria laboral y de servicios profesionales como consultor independiente, docente universitario y dirigente de organizaciones de los sectores cooperativo, educativo y empresarial.',
  },
  {
    id: 'maria-victoria-henao',
    order: 6,
    name: 'María Victoria Henao Hernández',
    company: 'Henao Hernández Abogados & Consultores S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/pqTqVp47khhzCA5vQEcEhp/Maria_Victoria_mejorada_con_IA_2.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/ieVnFXUpGfS1UHanonLJus/LOGO_HENAO_HERNANDEZ.jpg',
    bio: 'Socia directora de Henao Hernández Abogados & Consultores S.A.S., abogada con más de 40 años de experiencia y especialización en derecho comercial, propiedad intelectual, derecho administrativo y nuevas tecnologías. Asesora en marcas, patentes, registros sanitarios, modelos de negocio y franquicias. Ha ejercido como jueza, funcionaria pública, conferencista y docente.',
  },
  {
    id: 'julian-rivera',
    order: 7,
    name: 'Julián Ricardo Rivera Ríos',
    company: 'FRG Auditores y Consultores S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/pGeEvFfS57xT4xruWVUoHJ/Julian_mejorada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/kZT73ZhFeM33NLvYK6TCSc/FRG-Auditores-logo-Horizontal-Temp.jpg',
    bio: 'Socio gerente de FRG Auditores y Consultores S.A.S., contador público, ingeniero telemático, especialista en Finanzas y magíster en Seguridad Informática y Ciberseguridad. Combina experiencia contable y tributaria con auditoría de sistemas, control interno y evaluación de riesgos en plataformas ERP. Su trayectoria incluye revisoría fiscal, auditoría y protección de datos personales.',
  },
  {
    id: 'paola-jaramillo',
    order: 8,
    name: 'Paola Andrea Jaramillo Pineda',
    company: 'Holística J. Eastmann S.A.S.',
    photo: 'https://cdn.magicpatterns.com/uploads/kzHb7yYPZ7962NZmvE2o9o/Paola_mejorada_con_IA.webp',
    companyLogo: 'https://cdn.magicpatterns.com/uploads/swnvhAUaSLEyxvtXJB6vAU/LOGO_HOLISTICA.png',
    bio: 'Socia y gerente de Holística J. Eastmann S.A.S., empresa distribuidora exclusiva del Laboratorio Homeopático Alemán (LHA) en el suroccidente colombiano. Su actividad empresarial se desarrolla en el sector de la salud, mediante la distribución de productos del laboratorio y una oferta orientada a brindar soluciones para la salud humana y animal.',
  },
]
